import SelectFilter from '../templates/SelectFilter';
import { useGetProcedures } from '@vindr/services/actions/procedure.api';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const ProcedureName = ({
  title = 'Procedure Name',
  placeholder = 'Select Procedure Name',
  value,
  onChange,
  width = 200,
  multiple = false,
  ...props
}: SelectFilter & {
  multiple?: boolean;
}) => {
  const { t } = useTranslation('Vindoc');
  title = ['boolean', 'string'].includes(typeof title) ? title : t('Procedure Name');
  placeholder = placeholder || t('Select Procedure Name');

  const { data, isInitialLoading, isRefetching } = useGetProcedures({
    offset: 0,
    limit: 100,
  });
  const accounts = data?.data;

  const options = useMemo(
    () =>
      accounts?.map((item) => ({
        value: item.code,
        label: `[${item.code}] ${item.name}`,
      })),
    [accounts]
  );

  return (
    <SelectFilter
      {...(multiple && { mode: 'multiple' })}
      searchVietnamese
      loading={isInitialLoading || isRefetching}
      {...{ value, title, placeholder, onChange, options, width }}
      {...props}
    />
  );
};

export default memo(ProcedureName);
